import styled from 'styled-components';
import * as Text from 'theme/components/Text.style';
import colours from 'theme/atoms/colours';
import breakpoints from 'theme/atoms/breakpoints';
import * as Cards from 'theme/components/Cards.style';

export const SectionCard = styled(Cards.BaseCard)`
  border-radius: 28px;
  box-shadow: none;
  gap: 10px;
  padding: 20px;

  @media (max-width: ${breakpoints.tablet}) {
    border-radius: 24px;
    padding: 18px;
  }
`;

export const SectionHeader = styled('div')<{
  $first?: boolean;
}>`
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: ${({ $first }) => ($first ? '10px 0' : '20px 0 10px 0')};

  @media (max-width: ${breakpoints.tablet}) {
    padding: 15px 0 10px 0;
  }
`;

export const Rows = styled('div')`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Row = styled('div')`
  align-items: center;
  display: flex;
  gap: 20px;
  justify-content: space-between;

  &:not(:first-child) {
    border-top: 1px solid ${colours.neutral[200]};
  }
`;

export const RowListItem = styled('div')`
  align-items: center;
  display: flex;
  gap: 20px;
  justify-content: space-between;
  min-height: 50px;
  width: 100%;

  @media (max-width: ${breakpoints.tablet}) {
    flex-direction: ${({ $mobileColumn }) =>
      $mobileColumn ? 'column' : 'row'};
    align-items: ${({ $mobileColumn }) =>
      $mobileColumn ? 'stretch' : 'center'};
  }
`;

export const ColumnRowListItem = styled(RowListItem)`
  align-items: flex-start;
  flex-direction: column;
`;

export const Divider = styled('div')`
  height: 1px;
  width: 100%;
  background: rgba(234, 234, 235, 0.9);
`;

export const RowLabel = styled('div')`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
`;

export const RowLabelTopPadding = styled(RowLabel)`
  padding-top: 6px;
`;

export const RowControl = styled('div')`
  align-items: center;
  display: flex;
  justify-content: flex-end;
`;

export const RowDescription = styled(Text.Label)`
  color: ${colours.neutral[500]};
`;

export const PushNoticeCard = styled(SectionCard)`
  align-items: center;
  flex-direction: row;
  flex-shrink: 0;
  gap: 16px;
  justify-content: space-between;
  margin-bottom: 20px;

  @media (max-width: ${breakpoints.tablet}) {
    align-items: stretch;
    flex-direction: column;
  }
`;

export const PushNoticeMessage = styled('div')`
  align-items: center;
  display: flex;
  gap: 12px;
`;

export const PushNoticeIcon = styled('span')`
  align-items: center;
  background: ${colours.neutral[100]};
  border-radius: 50%;
  color: ${colours.neutral[900]};
  display: flex;
  flex-shrink: 0;
  height: 36px;
  justify-content: center;
  width: 36px;
`;

export const CardStack = styled('div')`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  gap: 20px;
`;

export const LoadStateCard = styled(SectionCard)`
  align-items: center;
  color: ${colours.neutral[500]};
  justify-content: center;
  min-height: 90px;
`;

export const NotificationsBody = styled('div')`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
`;
